export default __webpack_public_path__ + "static/media/pencil.597a2312.svg";